import { render, staticRenderFns } from "./pricing-details.vue?vue&type=template&id=37d21c53&scoped=true"
import script from "./pricing-details.vue?vue&type=script&lang=js"
export * from "./pricing-details.vue?vue&type=script&lang=js"
import style0 from "./pricing-details.vue?vue&type=style&index=0&id=37d21c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d21c53",
  null
  
)

export default component.exports